import { useCallback } from 'react';
import { calculatorBlocks } from '@/config/wordpress'; // const PREFIX = 'components: Editor: hooks: useShareOptions:';
// interface Params {}

export default function useShareOptions() {
  // Open the Wordpress Calculator Blocks
  // profile page in a new browser tab
  const onOpenCalculatorBlocksProfile = useCallback(() => {
    window.open(calculatorBlocks.profileUrl, '_blank');
  }, []);
  return {
    onOpenCalculatorBlocksProfile
  };
}